import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-pesquisa_7b99bb7e24184b3f4f046032cb87b0f9",
  "use": "ic-pesquisa_7b99bb7e24184b3f4f046032cb87b0f9-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ic-pesquisa_7b99bb7e24184b3f4f046032cb87b0f9\">\n    <path d=\"M15.867 14.32h-.818l-.284-.281a6.658 6.658 0 0 0 1.614-4.35 6.69 6.69 0 1 0-6.69 6.69c1.663 0 3.179-.61 4.349-1.612l.284.282v.815l5.144 5.137L21 19.467l-5.133-5.146zm-6.177 0a4.63 4.63 0 1 1 0-9.263 4.63 4.63 0 0 1 0 9.264z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id